import { ControlFacet } from '../models/controls/ControlFacet';

export const itemsScopeControl = new ControlFacet<{}, {
  /**
   * An error callback to be invoked by `ItemsScope` after it catches
   * and handles an render errors within its scope.
   */
  onError: (error: Error) => void;
  /**
   * The itemsScopeItemKey seen by components within the ItemsScope.
   * In general, do not override this as `ItemsScope` supplies it automatically.
   */
  itemsScopeItemKey: string;
}>('itemsScopeControl');
